
/* ADVERT */
export const GET_ADVERT_LISTING = "GET_ADVERT_LISTING";
export const GET_ADVERT_LISTING_SUCCESS = "GET_ADVERT_LISTING_SUCCESS";
export const GET_ADVERT_LISTING_FAIL = "GET_ADVERT_LISTING_FAIL";

export const GET_COE_BIDDING_LIST = "GET_COE_BIDDING_LIST";
export const GET_COE_BIDDING_LIST_SUCCESS = "GET_COE_BIDDING_LIST_SUCCESS";
export const GET_COE_BIDDING_LIST_FAIL = "GET_COE_BIDDING_LIST_FAIL";

export const GET_ADVERT_DETAILS = "GET_ADVERT_DETAILS";
export const GET_ADVERT_DETAILS_SUCCESS = "GET_ADVERT_DETAILS_SUCCESS";
export const GET_ADVERT_DETAILS_FAIL = "GET_ADVERT_DETAILS_FAIL";

export const GET_ADVERT_REMARK_LISTING = "GET_ADVERT_REMARK_LISTING";
export const GET_ADVERT_REMARK_LISTING_SUCCESS = "GET_ADVERT_REMARK_LISTING_SUCCESS";
export const GET_ADVERT_REMARK_LISTING_FAIL = "GET_ADVERT_REMARK_LISTING_FAIL";

export const GET_ADVERT_INQUIRY_LISTING = "GET_ADVERT_INQUIRY_LISTING";
export const GET_ADVERT_INQUIRY_LISTING_SUCCESS = "GET_ADVERT_INQUIRY_LISTING_SUCCESS";
export const GET_ADVERT_INQUIRY_LISTING_FAIL = "GET_ADVERT_INQUIRY_LISTING_FAIL";

export const GET_ERP_LISTING = "GET_ERP_LISTING";
export const GET_ERP_LISTING_SUCCESS = "GET_ERP_LISTING_SUCCESS";
export const GET_ERP_LISTING_FAIL = "GET_ERP_LISTING_FAIL";

export const GET_ERP_DETAILS = "GET_ERP_DETAILS";
export const GET_ERP_DETAILS_SUCCESS = "GET_ERP_DETAILS_SUCCESS";
export const GET_ERP_DETAILS_FAIL = "GET_ERP_DETAILS_FAIL";

export const CREATE_ADVERT = "CREATE_ADVERT";
export const CREATE_ADVERT_SUCCESS = "CREATE_ADVERT_SUCCESS";
export const CREATE_ADVERT_FAIL = "CREATE_ADVERT_FAIL";

export const UPDATE_ADVERT = "UPDATE_ADVERT";
export const UPDATE_ADVERT_SUCCESS = "UPDATE_ADVERT_SUCCESS";
export const UPDATE_ADVERT_FAIL = "UPDATE_ADVERT_FAIL";

export const BULK_UPDATE_ADVERT = "BULK_UPDATE_ADVERT";
export const BULK_UPDATE_ADVERT_SUCCESS = "BULK_UPDATE_ADVERT_SUCCESS";
export const BULK_UPDATE_ADVERT_FAIL = "BULK_UPDATE_ADVERT_FAIL";

export const REQUEST_MAKE_MODEL = "REQUEST_MAKE_MODEL";
export const REQUEST_MAKE_MODEL_SUCCESS = "REQUEST_MAKE_MODEL_SUCCESS";
export const REQUEST_MAKE_MODEL_FAIL = "REQUEST_MAKE_MODEL_FAIL";

export const DELETE_ADVERT = "DELETE_ADVERT";
export const DELETE_ADVERT_SUCCESS = "DELETE_ADVERT_SUCCESS";
export const DELETE_ADVERT_FAIL = "DELETE_ADVERT_FAIL";

export const REQUEST_SINGPASS = "REQUEST_SINGPASS";
export const REQUEST_SINGPASS_SUCCESS = "REQUEST_SINGPASS_SUCCESS";
export const REQUEST_SINGPASS_FAIL = "REQUEST_SINGPASS_FAIL";

export const RESET_ADVERT_STATE = 'RESET_ADVERT_STATE';
export const RESET_ADVERT_ACTION_STATE = 'RESET_ADVERT_ACTION_STATE';

export const SET_ERP_DETAILS_LOCAL = 'SET_ERP_DETAILS_LOCAL';